{
  "attachAria": "Прикрепить файл",
  "emptyHint": "Опишите вопрос — поддержка ответит здесь",
  "emptyTitle": "Здесь пока нет сообщений",
  "fileOpenAria": "Открыть вложение",
  "logAria": "Переписка по обращению",
  "newMessages": "Новые сообщения",
  "placeholder": "Напишите сообщение…",
  "placeholderDisabled": "Сообщения временно недоступны",
  "previewAria": "Посмотреть вложение",
  "previewCloseAria": "Закрыть просмотр",
  "removeAttachmentAria": "Удалить файл",
  "retry": "Повторить",
  "screenshotAria": "Сделать скриншот",
  "seen": "Прочитано",
  "sendAria": "Отправить сообщение",
  "sendFailed": "Не удалось отправить сообщение",
  "sending": "Отправляется…",
  "student": "Студент",
  "supportName": "Поддержка Skyeng",
  "today": "Сегодня",
  "yesterday": "Вчера",
  "you": "Вы"
}
